<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SmsPartnerDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/SmsPartnerDialog.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    NextButton,
    SmsPartnerDialog,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
  methods: {
    // O Short Code usa o mesmo painel de parceiro de Campanhas > SMS: ele cria
    // a caixa da operadora no backend, então aqui só abrimos o painel.
    openPartner() {
      this.$refs.partnerDialog?.open();
    },
    onPartnerSaved() {
      this.$store.dispatch('inboxes/get');
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="360dialog">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
          </option>
          <option value="shortcode">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.SHORTCODE') }}
          </option>
        </select>
      </label>
    </div>
    <Twilio v-if="provider === 'twilio'" type="sms" />
    <div
      v-else-if="provider === 'shortcode'"
      class="flex flex-col items-start gap-3 mt-2"
    >
      <p class="mb-0 text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.ADD.SMS.SHORTCODE.DESC') }}
      </p>
      <NextButton
        :label="$t('INBOX_MGMT.ADD.SMS.SHORTCODE.CONFIGURE')"
        icon="i-ph-gear-six"
        @click="openPartner"
      />
      <SmsPartnerDialog ref="partnerDialog" @saved="onPartnerSaved" />
    </div>
    <BandwidthSms v-else />
  </div>
</template>
